import { render, staticRenderFns } from "./businessUnitHistoryTab.vue?vue&type=template&id=17173d95&scoped=true&"
import script from "./businessUnitHistoryTab.vue?vue&type=script&lang=js&"
export * from "./businessUnitHistoryTab.vue?vue&type=script&lang=js&"
import style0 from "./businessUnitHistoryTab.vue?vue&type=style&index=0&id=17173d95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17173d95",
  null
  
)

export default component.exports